module.exports = __webpack_public_path__ + "a9cdbcbaa15e5842282cf5c4e872fa8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_3-768.jpg
// module id = 593
// module chunks = 0